import React from "react";
import { useShallow } from "zustand/react/shallow";
import { AnimationDuration } from "@uno/protocol";
import useStoreAnimation from "../../../store/useStoreAnimation";
import { AnimationValue } from "../../../types/Animation";

const useRoomPlayerAction = () => {
    const enqueueAnimation = useStoreAnimation(useShallow(state => state.enqueue));

    return React.useCallback((payload: { roomPlayer: { player: { id: string } }; action: string }) => {
        const { roomPlayer, action } = payload;

        const animation: AnimationValue = {
            effects: [{ transform: ["scale(0.7)", "scale(1) rotate(-5deg)", "scale(0) rotate(0deg)"] }],
            transitions: [{ duration: AnimationDuration.RoomPlayerAction, fill: "forwards", easing: "ease-in" }],
            duration: AnimationDuration.RoomPlayerAction,
            isAsynchronous: true
        };

        enqueueAnimation(roomPlayer.player.id, { name: action, ...animation, payload });    
    }, []);
}

export default useRoomPlayerAction;
